import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import moment from 'moment';
import { OutrightBetState } from './OutrightBet.state';
import { CompetitionFilter } from './CompetitionFilter';
import { MarketsFilter } from './MarketsFilter';
import { MarketItem } from './MarketItem';
import Loading from 'src/components/Loading';
import { EachWay, MarketNameWrapper } from './OutrightBet.style';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';

interface PropsTypes {
    sport: string;
    userId: number;
}

export const OutrightBet = observer('OutrightBet', (props: PropsTypes) => {
    const appState = useAppStateContext();
    const [outrightBetStateMap] = useState(
        () => new AutoMap<string, OutrightBetState>((sportId) => new OutrightBetState(appState, sportId))
    );
    const outrightBetState = outrightBetStateMap.get(props.sport);

    return (
        <div className='outright-tab'>
            {outrightBetState.competitions.length > 0 ? (
                <CompetitionFilter outrightBetState={outrightBetState} />
            ) : null}

            <div className='outright-tab__sub-section'>
                {outrightBetState.marketsFilter.length > 0 ? (
                    <MarketsFilter outrightBetState={outrightBetState} />
                ) : null}

                {outrightBetState.events.length > 0 ? (
                    outrightBetState.events.map((event) => {
                        return (
                            <div key={event.id}>
                                <div className='outright-tab__date'>
                                    <div>{event.name}</div>
                                    {`Start Time: ${moment(event.timeSettingsStartTime).format('DD MMM HH:mm')}`}
                                </div>

                                {event.markets.map((market) => {
                                    const marketModel = appState.websocketV2.getMarket(market.id);

                                    if (marketModel === null) {
                                        return null;
                                    }

                                    const places = marketModel.eachWay?.terms[0]?.places ?? null;
                                    const reduction = marketModel.eachWay?.terms[0]?.reduction ?? null;

                                    return (
                                        <div key={marketModel.id}>
                                            <MarketNameWrapper>
                                                <h3>{outrightBetState.selectedMarketName}</h3>
                                                {places !== null && reduction !== null ? (
                                                    <EachWay>{`Each Way ${reduction} ${places} Places`}</EachWay>
                                                ) : null}
                                            </MarketNameWrapper>
                                            <MarketItem
                                                marketModel={marketModel}
                                                userId={props.userId}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })
                ) : (
                    <p>There are no available selections</p>
                )}

                <Loading active={outrightBetState.queryModel === null && outrightBetState.competitions.length === 0} />
            </div>
        </div>
    );
});
